import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import productType from "../../assets/img/product-type-icon.svg";
import imageIcon from "../../assets/img/image-icon.svg";
import pricingIcon from "../../assets/img/pricing.svg";
import tickIconPrimary from "../../assets/img/white-tick-icon.svg";
import descriptionIcon from "../../assets/img/description.svg";
import infoIcon from "../../assets/img/info.svg";
import customTheme from "../../assets/img/custom-theme.png";
import filesIcon from "../../assets/img/files.svg";
import returnIcon from "../../assets/img/modals/return.svg";
import removeicon from "../../assets/img/products/removeicon.svg";
import * as $ from "jquery";
import { Link, useHistory } from "react-router-dom";
import { Alert, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import CroppieModal from "../croppie-modal";
import { hideLoader, showLoader } from "../loader";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../utils/url";
import ErrorMessage from "../errors/errorMessage";
import ModalErrors from "../errors/modal-errors";
import FormFieldError from "../errors/formFieldError";
import ProductStep2 from "./productStep2";
import SelectedThemeInput from "../custom-theme/commons/select-theme-input";
import SelectedCustomTheme from "../custom-theme/commons/select-custom-theme";
import IroColorPicker from "../custom-theme/IroColorPicker";
const ProductStep1 = ({ showProductStep2, nextStep, onClose,error, setError ,errorMessage, setErrorMessage , values, setValues, defaultBranding}) => {
    const history  = useHistory();
    const { basePath, slug } = useSelector((state) => state?.slugReducer);
    const brandings = useSelector(state => state?.allBrandingReducer);
    const [selectedBrand, setSelectedBrand] = useState({id:defaultBranding?.id,logo:defaultBranding?.logo,name:defaultBranding?.brand_name});
    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValues = { ...values, [name]: value };
    
        if (name === 'title') {
            let slug = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-');
            slug = slug.replaceAll(' ', '-');
            updatedValues.product_slug = slug;
        }
    
        setValues(updatedValues);
    };
    const handleSelectValue = (val) => {
        setSelectedBrand({id:val?.id,logo:val?.logo,name:val?.brand_name})
        setValues({...values,"branding_id":val?.id})
    };
    const addBrand = () => {
        history.push({
            pathname:basePath + "/settings",
            state: {
                defaultPage: "branding"
            }
        });
    };
    function handleSubmit(e) {
        e.preventDefault(); 
        nextStep(); 
      }
    return (
        <Modal centered className="rename-modal new-modal" show={showProductStep2} onHide={onClose}>
                <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
                    <div class="modal-header">
                        Create Campaign
                        <button type="button" class="close" onClick={onClose} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body pb-0">
                        <form name="product_type" onSubmit={handleSubmit}>
                            <ErrorMessage error={error} />
                                <div className="form-group">
                                        <label className="productlabels">
                                            Campaign Title
                                            <small className="text-red">*</small>
                                        </label>
                                        <input
                                            value={values?.title}
                                            onChange={handleChange}
                                            type="text"
                                            className="zaapGlobal-input h-30px"
                                            name="title"
                                            placeholder="eg: May SaaS Leads"
                                        />
                                        <FormFieldError error={error?.title} />
                                </div>
                                <div className="form-group mt-20px">
                                        <label className="productlabels">
                                            Pick Brand
                                            <small className="text-red">*</small>
                                        </label>
                                        <div class="table-action-dropdown p-1 d-flex justify-content-between align-items-center gap-2 cursor-pointer zaapGlobal-input dropdown-toggle noselect dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                            <span className="d-flex align-items-center gap-2">
                                                <span>
                                                    <img className="brand-logo" width={"22px"} height={"22px"} src={selectedBrand?.logo} alt="" />
                                                </span>
                                                <span>
                                                    {selectedBrand?.name}
                                                </span>
                                            </span>
                                        </div>
                                        <ul class="dropdown-menu brand-dropdown-menu" aria-labelledby="table-action-dropdown">
                                            {brandings?.length > 0 && (
                                                brandings.map((val, idx) => (
                                                    <li key={idx} onClick={() => handleSelectValue(val)}>
                                                        <a class={`dropdown-item cursor-pointer border-radius-9`} >
                                                            <span><img className="brand-logo" width={"25px"} height={"25px"} src={val?.logo} alt="" /></span>
                                                            <span>{val?.brand_name} </span>
                                                        </a>
                                                    </li>
                                                ))
                                            )}
                                            <li onClick={() => addBrand()}>
                                                <a class={`dropdown-item cursor-pointer border-radius-9`} >
                                                    <span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                            <rect width="22" height="22" rx="7" fill="#DBEDFF"/>
                                                            <path d="M11 6V16M6 11H16" stroke="#1188FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </span>
                                                    <span>Add Brand</span>
                                                </a>
                                            </li>
                                        </ul>
                                </div>
                        </form>
                    </div>
                    <div className='d-flex gap-2 mt-20px align-items-center justify-content-center new-modal-footer'>
                            <button onClick={onClose} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>Cancel</button>
                            <button className='fs-12 w-50 shadow-none  project-blue-btn' type='submit' onClick={nextStep}> Create </button>
                        </div>
                </div>
            {/* <CroppieModal show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} /> */}
        </Modal>
    );
};
export default ProductStep1;
